import PropTypes from 'prop-types';
import React from 'react';
import Header from 'src/components/header';
import Loader from 'src/components/loader';
import NotFound from 'src/components/not-found';
import {
  MATERIAL_BATCH_ACTIONS,
  PERMANENT_CONTAINER_ACTIONS_VERBOSE,
} from 'src/utils/constants';
import userPropType from 'src/utils/user-prop-type';

const PermanentContainerActionPageWrapper = ({
  id,
  user,
  action,
  httpError,
  customErrorText,
  customHeaderText,
  isLoading,
  children,
}) => {
  if (httpError || customErrorText) {
    return (
      <>
        <Header excludeFromHistory title="Error" user={user} />
        {
          (httpError) ? (
            <main role="main" className="text-center">
              <NotFound id={id} />
            </main>
          ) : (
            <div className="alert alert-danger m-4" role="alert">
              <h1 className="h5 header-margin">Error</h1>
              {
                customErrorText ?
                  (<p className="mb-0">{customErrorText}</p>) :
                  (<p className="mb-0">Something Went Wrong.</p>)
              }
            </div>
          )

        }
      </>
    );
  }

  let verboseAction = customHeaderText || PERMANENT_CONTAINER_ACTIONS_VERBOSE[action];

  return (
    <>
      <Header title={verboseAction} user={user} />
      <main role="main" className="text-center">
        <div>
          {isLoading ? <Loader inline text="container" className="text-muted" /> : children}
        </div>
      </main>
    </>
  );
};

PermanentContainerActionPageWrapper.propTypes = {
  id: PropTypes.string,
  action: PropTypes.oneOf(Object.values(MATERIAL_BATCH_ACTIONS)).isRequired,
  user: userPropType,
  httpError: PropTypes.shape({}),
  customErrorText: PropTypes.string,
  children: PropTypes.node,
  isLoading: PropTypes.bool,
  customHeaderText: PropTypes.string,
};

PermanentContainerActionPageWrapper.defaultProps = {
  id: '',
  user: null,
  children: null,
  httpError: null,
  customErrorText: '',
  isLoading: false,
  customHeaderText: '',
};

export default PermanentContainerActionPageWrapper;
